import get from 'lodash/get';

interface Color {
    front: string;
    back: string;
}

interface Colors {
    [index: string]: Color;
}

export const bookingProgression = {
    to_deal: 'À traiter',
    signature: 'Signature',
    recording: 'Enregistrement',
    funding: 'Conditions Suspensives',
    actable: 'Actabilité',
    acted: 'Acté',
    commissioned: 'Commissionné',
};

export const bookingProgressionColors: Colors = {
    to_deal: {
        front: 'white',
        back: '#6CA6D9',
    },
    signature: {
        front: 'white',
        back: '#C37A9D',
    },
    recording: {
        front: 'white',
        back: '#E26667',
    },
    funding: {
        front: 'white',
        back: '#F8B170',

    },
    actable: {
        front: 'white',
        back: '#F2C246',
    },
    acted: {
        front: 'white',
        back: '#B3D6A9',
    },
    commissioned: {
        front: 'white',
        back: '#66A756',
    },
};

export const formatBookingProgression = (value: string) => {
    return get(bookingProgression, value, value);
};
